import React from "react"
import "./index.css"

const DashboardPill = props => (
  <div className={`dashboard-pill type${" " + props.type.toLowerCase()}`}>
    <span>
      {props.icon && (<span>{props.icon}</span>)}
      {props.children}
    </span>
  </div>
)

export default DashboardPill



// WEBPACK FOOTER //
// ./src/components/dashboard-pill/DashboardPill.js